import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form/dist/types';

export const useHandleValidSettings = (
  methods: UseFormReturn<any>,
  validPropName = 'valid',
  activePropName = 'active'
) => {
  const { watch, setValue } = methods;

  const isValid = watch(validPropName);

  useEffect(() => {
    if (isValid === false) {
      setValue(activePropName, false);
    }
  }, [isValid]);
  return isValid;
};
